var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "t-strip",
    style: {
      left: _vm.tweenLeft + 'px'
    },
    attrs: {
      "aria-live": "polite",
      "role": "document",
      "tabindex": "0"
    },
    on: {
      "keydown": _vm.keydown
    }
  }, _vm._l(_vm.nearbyPages, function (page) {
    return _c('div', {
      key: page.pageNum,
      staticClass: "page-wrapper",
      style: {
        left: _vm.pageWidth * page.stripOffset + 'px',
        width: _vm.viewerWidth + 'px'
      },
      on: {
        "touchstart": _vm.touchstart,
        "touchend": _vm.touchend
      }
    }, [_c('Page', _vm._b({
      ref: "page".concat(page.pageNum),
      refInFor: true,
      attrs: {
        "offScreen": page.pageNum !== _vm.pageNum,
        "searchTerms": _vm.searchTerms,
        "viewerHeight": _vm.viewerHeight,
        "viewerWidth": _vm.viewerWidth
      }
    }, 'Page', page, false))], 1);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }